import {css} from '@logistics-frontend/blocks/theme/css'

export const paper = css`
  :last-child {
    border-end-end-radius: 0;
    border-end-start-radius: 0;
  }
  :not(:last-child) {
    block-size: unset;
  }
`

export const input = css`
  &:before {
    content: none;
  }
`

export const inputContainer = css`
  inline-size: 100%;
`
